import { AssessmentResult } from '../../types/assessment';
import { scoreClass, scoreBadge, scoreBadgeLabel, barColor } from './scoreHelpers';
import { computeScores } from './computeScores';
import TiCard from '../common/TiCard';

interface Props {
  result: AssessmentResult;
}

export default function ScoringIndexesCard({ result }: Props) {
  const { is_opinion } = result;
  const c = computeScores(result);

  return (
    <TiCard label="Scoring indexes" animate fullHeight>
      {!is_opinion && (
        <div style={{ marginBottom: 10 }}>
          <div className="group-label">Accuracy inputs — 60% of final score</div>
          <div className="two-grid">
            <div className="tile">
              <div className="tile-label">1. Quality index <span className="badge bg-blue" style={{ marginLeft: 4 }}>30%</span></div>
              <div className={`tile-score ${scoreClass(c.qualityTotal, 100)}`}>
                {c.qualityTotal} <span>/ 100</span>
              </div>
              <div className="tile-bar-row">
                <div className="bar-bg" style={{ marginLeft: 0 }}>
                  <div className="bar-fill" style={{ width: `${c.qualityTotal}%`, background: barColor(c.qualityTotal, 100) }} />
                </div>
                <span className={`badge ${scoreBadge(c.qualityTotal, 100)}`} style={{ marginLeft: 8 }}>{scoreBadgeLabel(c.qualityTotal, 100)}</span>
              </div>
            </div>
            <div className="tile">
              <div className="tile-label">2. Source veracity <span className="badge bg-blue" style={{ marginLeft: 4 }}>30%</span></div>
              <div className={`tile-score ${scoreClass(c.veracityFinal, 100)}`}>
                {c.veracityFinal} <span>/ 100</span>
              </div>
              <div className="tile-bar-row">
                <div className="bar-bg" style={{ marginLeft: 0 }}>
                  <div className="bar-fill" style={{ width: `${(c.veracityFinal / 100) * 100}%`, background: barColor(c.veracityFinal, 100) }} />
                </div>
                <span className={`badge ${scoreBadge(c.veracityFinal, 100)}`} style={{ marginLeft: 8 }}>{scoreBadgeLabel(c.veracityFinal, 100)}</span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div>
        <div className="group-label">Emotional inputs — 40% of final score</div>
        <div className="two-grid">
          <div className="tile">
            <div className="tile-label">3. Feeling valence <span className="badge bg-gray" style={{ marginLeft: 4 }}>20%</span></div>
            <div className={`tile-score ${is_opinion ? '' : scoreClass(c.valenceTotal, 100)}`}>
              {is_opinion ? 'N/A' : c.valenceTotal} <span>/ 100</span>
            </div>
            {!is_opinion && (
              <div className="tile-bar-row">
                <div className="bar-bg" style={{ marginLeft: 0 }}>
                  <div className="bar-fill" style={{ width: `${c.valenceTotal}%`, background: barColor(c.valenceTotal, 100) }} />
                </div>
                <span className={`badge ${scoreBadge(c.valenceTotal, 100)}`} style={{ marginLeft: 8 }}>{scoreBadgeLabel(c.valenceTotal, 100)}</span>
              </div>
            )}
          </div>
          <div className="tile">
            <div className="tile-label">4. Manipulation index <span className="badge bg-gray" style={{ marginLeft: 4 }}>20%</span></div>
            <div className={`tile-score ${scoreClass(c.manipulationTotal, 100)}`}>
              {c.manipulationTotal} <span>/ 100</span>
            </div>
            <div className="tile-bar-row">
              <div className="bar-bg" style={{ marginLeft: 0 }}>
                <div className="bar-fill" style={{ width: `${c.manipulationTotal}%`, background: barColor(c.manipulationTotal, 100) }} />
              </div>
              <span className={`badge ${scoreBadge(c.manipulationTotal, 100)}`} style={{ marginLeft: 8 }}>{scoreBadgeLabel(c.manipulationTotal, 100)}</span>
            </div>
          </div>
        </div>
      </div>
      {!is_opinion && c.valenceTotal < 60 && c.manipulationTotal >= 70 && (
        <div className="methodology-note" style={{ marginTop: 14 }}>
          RED/ORANGE Feeling Valence combined with GREEN Manipulation is the expected pattern for rigorous investigative journalism on serious subjects. The emotional intensity reflects the gravity of what is reported, not manipulation of the reader.
        </div>
      )}
    </TiCard>
  );
}
